import compose from 'recompose/compose';
import AddPromo from '../components/AddPromo';
import withToggle from '../../common/hoc/withToggle';
import withRenderOnPromotion from '../hoc/withRenderOnPromotion';

const AddPromoContainer = compose(
  withRenderOnPromotion,
  withToggle(),
)(AddPromo);

export default AddPromoContainer;
